<div
  ui-submenu-title
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [uiTitleIcon]="nzIcon"
  [uiTitle]="nzTitle"
  [uiTitleMode]="mode"
  [uiTitleDisabled]="nzDisabled"
  [uiTitleIsInsideDropDown]="isMenuInsideDropDown"
  [uiTitlePaddingLeft]="nzPaddingLeft || inlinePaddingLeft"
  (uiTitleMouseState)="setMouseEnterState($event)"
  (uiTitleToggle)="toggleSubMenu()">
  <ng-content select="[title]" *ngIf="!nzTitle"></ng-content>
</div>
<div *ngIf="mode === 'inline'; else nonInlineTemplate" ui-submenu-inline-child [mode]="mode" [nzOpen]="nzOpen" [menuClass]="nzMenuClassName" [templateOutlet]="subMenuTemplate"></div>
<ng-template #nonInlineTemplate>
  <ng-template
    cdkConnectedOverlay
    (positionChange)="onPositionChange($event)"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayWidth]="triggerWidth!"
    [cdkConnectedOverlayOpen]="nzOpen"
    [cdkConnectedOverlayTransformOriginOn]="'.ant-menu-submenu'">
    <div
      ui-submenu-none-inline-child
      [theme]="theme"
      [mode]="mode"
      [nzOpen]="nzOpen"
      [position]="position"
      [nzDisabled]="nzDisabled"
      [isMenuInsideDropDown]="isMenuInsideDropDown"
      [templateOutlet]="subMenuTemplate"
      [menuClass]="nzMenuClassName"
      (subMenuMouseState)="setMouseEnterState($event)"></div>
  </ng-template>
</ng-template>

<ng-template #subMenuTemplate>
  <ng-content></ng-content>
</ng-template>
